<script>
  import { createEventDispatcher } from "svelte";
  import Icon from "./helpers/Icon.svelte";
  import Start from "./Intro.Start.svelte";
  import sxm from "../svg/sxm.svg";
  import sirius from "../svg/sirius.svg";
  import pandora from "../svg/pandora.svg";
  import copy from "../data/doc.json";
  import { mode, loaded } from "../stores/global.js";
  import fx from "../utils/fx.js";

  const dispatch = createEventDispatcher();

  const onStart = () => {
    if ($mode === "loaded") {
      dispatch("start");
      fx("zoom");
    }
  };
</script>

<section id="intro" class:is-visible="{['loading', 'loaded'].includes($mode)}">
  <div class="logos">
    <span
      ><a href="https://www.sxmmedia.com/" aria-label="SXM Media">{@html sxm}</a
      ></span
    >
    <span>{@html sirius}</span>
    <span>{@html pandora}</span>
  </div>

  <div class="info">
    <h1 class="hed">
      <strong>{@html copy.intro.hed}</strong>
    </h1>
    <p class="dek">{copy.intro.dek}</p>
    <div class="start">
      <button on:click="{onStart}">
        <Start />
        <span>{$loaded === 1 ? copy.intro.start : "Loading..."}</span>
      </button>
    </div>
    <p class="warning">
      <span>{copy.intro.warning}</span>
      <span><Icon stroke="var(--base-gray-medium)" name="headphones" /></span>
    </p>
  </div>
</section>

<style>
  section {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    pointer-events: none;
    opacity: 0;
    transition: opacity 500ms;
  }

  section.is-visible {
    opacity: 1;
    pointer-events: auto;
    filter: blur(0);
  }

  .logos {
    width: 100%;
    max-width: 18em;
    margin: 0 auto;
    margin-bottom: 3em;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    position: absolute;
    top: 1.5rem;
    left: 1.5rem;
  }

  .logos span {
    display: block;
    margin-right: 1em;
  }

  .logos span:first-of-type {
    flex-grow: 1;
  }

  .logos span:last-of-type {
    transform: translateY(15%);
  }

  .info {
    max-width: 40rem;
    margin: 0 auto;
  }

  .dek {
    max-width: 34rem;
    margin: 3em auto;
    text-align: center;
  }

  .hed {
    font-weight: 900;
    font-size: 42px;
    margin: 0 auto;
    text-align: center;
  }

  .warning {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    line-height: 1;
    margin-top: 2em;
  }

  .warning span {
    display: block;
    color: var(--base-gray-medium);
  }

  .warning span:last-of-type {
    font-size: 1.5em;
    margin-left: 0.5em;
  }

  .start button {
    display: block;
    margin: 0 auto;
    padding: 0;
    background-color: transparent;
    color: var(--base-white);
    border: none;
    border-radius: 50%;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 14px;
    position: relative;
    box-shadow: 0 0 8px 16px rgba(0, 0, 0, 1);
  }

  .start button span {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
  }

  @media only screen and (max-width: 640px) {
    .logos {
      transform-origin: 0 0;
      transform: scale(0.75) translate(-50%, 0);
      left: 50%;
    }

    section {
      display: block;
      padding: 0 1em;
    }

    .hed {
      margin-top: 3em;
      line-height: 1.4;
      font-size: 32px;
      max-width: 10em;
    }

    .dek {
      text-align: left;
      font-size: 14px;
    }
  }

  @media only screen and (max-height: 600px) {
    section {
      justify-content: flex-end;
    }

    .hed {
      font-size: 32px;
    }

    .dek {
      margin: 2em auto;
    }
  }
</style>
